<div *ngIf="show" [class]="[type, 'alert']" role="alert">
  <div class="alert__content" [ngClass]="{'centered': centerContent}">
    <div class="alert__message" [ngClass]="showIcon ?  'icon '+ type+ '-icon' : ''"><ng-content></ng-content></div>
    <button lib-button *ngIf="dismissible" theme="link" (click)="hide()">Dismiss</button>
  </div>
</div>